module.exports = __webpack_public_path__ + "bab4f6e960ecf685b473846fd7356d8e.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-BoldItalic.eot
// module id = 719
// module chunks = 0